import { OptionsObject, useSnackbar } from 'notistack';
import { useCallback } from 'react';

export function useNotifications({ variant }: OptionsObject) {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    message => {
      enqueueSnackbar(message, { variant: variant });
    },
    [enqueueSnackbar, variant]
  );
}
